import { useActiveSalesCampaignCodes } from "~/SalesCampaign/useActiveSalesCampaignCodes";
import { useDispatch, useSelector } from "react-redux";
import { type RootState } from "~/redux/store";
import { updateCampaignFilterThunk } from "~/Search/redux/actions";
import Toggle from "~/common/components/Toggle/Toggle";
import { SaleTag } from "~/SalesCampaign/components/SaleTag/SaleTag";
import { useTranslation } from "react-i18next";
import { selectIsFilterActive } from "~/Search/redux/searchSelectors";
import { styled } from "@mui/material";
import { ICON_MARGIN } from "~/styles/cssConstants";

interface Props {
  className?: string;
}

export const SalesFilter = (props: Props) => {
  const { t } = useTranslation();
  const activeSalesCampaignCodes = useActiveSalesCampaignCodes();

  const isActive = useSelector(selectIsFilterActive);
  const hasCampaignResults = useSelector(selectHasCampaignResults);
  const dispatch = useDispatch();
  const toggle = () => {
    const codes = isActive ? [] : activeSalesCampaignCodes;
    dispatch(updateCampaignFilterThunk(codes));
  };

  if (!activeSalesCampaignCodes.length || !hasCampaignResults) {
    return null;
  }

  return (
    <Root className={props.className}>
      <Toggle checked={isActive} onCheck={toggle} />
      <span>{t("feature.salesCampaign.searchFilter")}</span>
      <SaleTag size={16} />
    </Root>
  );
};
const selectHasCampaignResults = (state: RootState) => state.srp.hasCampaignResults;

const Root = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: ICON_MARGIN,
}));
